import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CommunityDto, LgaDto } from '@cradua/data';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-community',
  templateUrl: './community.component.html',
  styleUrls: ['./community.component.scss'],
})
export class CommunityComponent implements OnChanges {
  @Input() communities: CommunityDto[];
  @Input() lgas: LgaDto[];
  communityForm: FormGroup;
  communityFormArray: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() changeEmit = new EventEmitter<CommunityDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  filteredDelete: Array<any> = [];
  filteredCommunity: Array<any> = [];
  status: boolean;
  selectedCommunityId: any;
  selectedIndex = null;

  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createCommunityForm();
  }

  createCommunityForm() {
    this.communityFormArray = this.fb.group({ Communities: this.fb.array([]) });
    this.communityForm = this.fb.group({
      CommunityName: ['', Validators.required],
      LgaId: this.selectedCommunityId,
      id: null,
    });
  }

  // method to display companies
  setCommunity() {
    const control = this.communityFormArray.controls.Communities as FormArray;
    this.filteredCommunity.forEach((e) => {
      control.push(
        this.fb.group({
          CommunityName: e.CommunityName,
          LgaId: e.LgaId,
          id: e.id,
        })
      );
    });
  }

  // method to add Company
  addCommunity(community: CommunityDto) {
    console.log('community');
    const control = this.communityFormArray.controls.Communities as FormArray;
    control.insert(
      0,
      this.fb.group({
        CommunityName: community.CommunityName,
        LgaId: this.selectedCommunityId,
      })
    );
  }

  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.communityFormArray.controls.Communities as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter community
  selectLga(event: string) {
    this.filteredCommunity = this.communities.filter((s) => s.LgaId === event);
    this.selectedCommunityId = event;
    const control = this.communityFormArray.controls.Communities as FormArray;

    if (this.filteredCommunity.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setCommunity();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  print(event: any) {
    window.print();
  }
  // method to delete company from arrary list
  deleteCommunity(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.communityFormArray.controls
          .Communities as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.communities.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.communities[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: CommunityDto) {
    if (this.communityForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.communityFormArray
        .get('Communities')
        ['controls'][this.selectedIndex].patchValue({
          CommunityName: formValue.CommunityName,
        });
    } else {
      this.addCommunity(formValue);
    }
    this.selectedIndex = null;
    this.communityForm.reset();
  }

  onEdit(index, value: CommunityDto) {
    this.selectedIndex = index;
    this.communityForm.patchValue({ CommunityName: value.CommunityName });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.communityForm.reset();
  }

  onSubmit(formValue: any) {
    formValue.type = 'community';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length > 0) {
      this.filteredDelete.unshift('community');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
